import { Box, Button, Grid, Tab, Tabs, Typography } from "@mui/material";
import { Dialog, DialogContent, DialogTitle, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import BusTicketView from "./BusTicketView";
import { useEffect, useState } from "react";
import Deliveryimg from "../img/timeiconnew.png";
import Deliveryimg1 from "../img/timeiconnew1.png";
import Deliveryimg2 from "../img/timeiconnew2.png";
import { AuthAxios } from "../Utilities/CommonAxios";
import showToast from "../Utilities/showToast";
import Swal from "sweetalert2";

const History = ({ bookingHistory, value }) => {
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [showTicket, setShowTicket] = useState(false);
  const [selectedTicket, setSelectedTicket] = useState(null);
  const [isDownload, setIsDownload] = useState(false);
  const handleViewTicket = (ticket) => {
    setSelectedTicket(ticket);
    setShowTicket(true);
    setOpenDialog(true);
  };

  const handleCancel = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to cancel?",
      icon: "warning",
      showCancelButton: true,
      cancelButtonText: "No",
      confirmButtonText: "Yes,Cancel",
      confirmButtonColor: "#ff5714",
      cancelButtonColor: "#9e9e9eff",
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: "Cancelled",
          text: "Action has been cancelled",
          icon: "success",
        });
      }
    });
  };

  const handleDownloadTicket = (ticket) => {
    setSelectedTicket(ticket);
    setShowTicket(false);
    setIsDownload(true);
    setTimeout(() => {
      setIsDownload(false);
    }, 1000);
  };
  const handleOpen = (index) => {
    setSelectedIndex(index);
    setOpenDialog(true);
  };

  const handleClose = () => setOpenDialog(false);
  const getStatusStyle = (status) => {
    if (!status) return { bg: "#f3f4f6", color: "#374151" };

    switch (status.toLowerCase()) {
      case "cancelled":
        return { bg: "#fee2e2", color: "red" };
      case "completed":
        return { bg: "#dcfce7", color: "#166534" };
      case "upcoming":
        return { bg: "#dbeafe", color: "#12398c" };
      default:
        return { bg: "#f3f4f6", color: "#374151" };
    }
  };
  return (
    <>
      {bookingHistory.length !== 0 ? (
        bookingHistory.map((ticket, i) => {
          const { bg, color } = getStatusStyle(ticket.status);
          return (
            <Box
              key={i}
              sx={{
                padding: "20px",
                borderRadius: "8px",
                border: "1px solid #e5e5e5",
                marginBottom: "15px",
              }}
            >
              <Grid container spacing={2}>
                <Grid size={{ md: 10, xs: 12 }}>
                  <Typography
                    sx={{
                      fontFamily: '"Segoe UI", sans-serif',
                      fontSize: "15px",
                      fontWeight: "500",
                      textAlign: "left",
                      color: "#0e182b",
                      marginRight: "4px",
                    }}
                  >
                    <img
                      src={Deliveryimg}
                      alt=""
                      style={{ verticalAlign: "middle", marginRight: "5px" }}
                    />
                    {ticket?.pnr_number}{" "}
                    <span
                      style={{
                        padding: "3px 6px",
                        borderRadius: "6px",
                        backgroundColor: bg,
                        color,
                        // backgroundColor: "#dbeafe",
                        fontSize: "13px",
                        fontWeight: "500",
                        // color: "#12398c",
                      }}
                    >
                      {ticket.status}
                    </span>
                  </Typography>
                </Grid>
                <Grid
                  size={{ md: 2, xs: 12 }}
                  sx={{
                    textAlign: "end",
                    "@media (max-width:600px)": {
                      textAlign: "unset",
                    },
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: '"Segoe UI", sans-serif',
                      fontSize: "16px",
                      fontWeight: 600,
                      textAlign: "right",
                      color: "#030213",
                      "@media (max-width:600px)": {
                        textAlign: "left",
                      },
                    }}
                  >
                    ₹{ticket?.basic_fare}
                  </Typography>
                </Grid>
              </Grid>
              <Grid container spacing={2} sx={{ marginTop: "20px" }}>
                <Grid size={{ md: 4, xs: 12 }}>
                  <Typography
                    sx={{
                      fontFamily: '"Segoe UI", sans-serif',
                      fontSize: "14px",
                      fontWeight: "normal",
                      textAlign: "left",
                      color: "#717182",
                    }}
                  >
                    Route
                  </Typography>

                  <Typography
                    sx={{
                      fontFamily: '"Segoe UI", sans-serif',
                      fontSize: "14px",
                      fontWeight: "normal",
                      textAlign: "left",
                      color: "#0e182b",
                    }}
                  >
                    {ticket?.passenger_details?.[0]?.boarding_point} →{" "}
                    {ticket?.passenger_details?.[0]?.dropping_point}
                    {/* Chennai → Bengaluru */}
                  </Typography>
                </Grid>
                <Grid size={{ md: 4, xs: 12 }}>
                  <Typography
                    sx={{
                      fontFamily: '"Segoe UI", sans-serif',
                      fontSize: "14px",
                      fontWeight: "normal",
                      textAlign: "left",
                      color: "#717182",
                    }}
                  >
                    Booked Date & Time
                  </Typography>
                  <Typography
                    sx={{
                      fontFamily: '"Segoe UI", sans-serif',
                      fontSize: "14px",
                      fontWeight: "normal",
                      textAlign: "left",
                      color: "#0e182b",
                    }}
                  >
                    {ticket?.booking_date}
                  </Typography>
                </Grid>
                <Grid size={{ md: 4, xs: 12 }}>
                  <Typography
                    sx={{
                      fontFamily: '"Segoe UI", sans-serif',
                      fontSize: "14px",
                      fontWeight: "normal",
                      textAlign: "left",
                      color: "#717182",
                    }}
                  >
                    Operator
                  </Typography>
                  <Typography
                    sx={{
                      fontFamily: '"Segoe UI", sans-serif',
                      fontSize: "14px",
                      fontWeight: "normal",
                      textAlign: "left",
                      color: "#0e182b",
                    }}
                  >
                    {ticket?.vehicle_operator_name}
                  </Typography>
                </Grid>
              </Grid>
              <Grid
                container
                spacing={2}
                sx={{ marginTop: "20px", alignItems: "center" }}
              >
                <Grid size={{ md: 8, xs: 12 }}>
                  <Typography
                    sx={{
                      fontFamily: '"Segoe UI", sans-serif',
                      fontSize: "14px",
                      fontWeight: "normal",
                      textAlign: "left",
                      color: "#717182",
                    }}
                  >
                    {ticket?.total_tickets} passengers
                  </Typography>
                </Grid>

                {value !== 3 && value !== 4 && (
                  <Grid
                    size={{ md: 4, xs: 12 }}
                    sx={{
                      textAlign: "end",
                      "@media (max-width:600px)": {
                        textAlign: "unset",
                      },
                    }}
                  >
                    <Button
                      variant="outlined"
                      sx={{
                        fontFamily: '"Segoe UI", sans-serif',
                        fontSize: "13px",
                        fontWeight: "normal",
                        textAlign: "center",
                        color: "#0e182b",
                        textTransform: "capitalize",
                        borderRadius: "6px",
                        border: "solid 1px #e5e5e5",
                        marginRight: "10px",
                        "@media (max-width:600px)": {
                          width: "100%",
                          marginBottom: "10px",
                        },
                      }}
                      // onClick={() => handleOpen(ticket, i)}
                      onClick={() => {
                        handleViewTicket(ticket);
                        // setAutoDownload(false); // ensure NOT auto download
                        // setOpenDialog(true);
                      }}
                    >
                      View Ticket
                    </Button>

                    <Button
                      variant="outlined"
                      sx={{
                        fontFamily: '"Segoe UI", sans-serif',
                        fontSize: "13px",
                        fontWeight: "normal",
                        textAlign: "center",
                        color: "#0e182b",
                        textTransform: "capitalize",
                        borderRadius: "6px",
                        border: "solid 1px #e5e5e5",
                        marginRight: "10px",
                        "@media (max-width:600px)": {
                          width: "100%",
                          marginBottom: "10px",
                        },
                      }}
                      onClick={() => {
                        handleDownloadTicket(ticket);
                        // setAutoDownload(true);
                        // setOpenDialog(true);
                      }}
                    >
                      Download
                    </Button>
                    <Button
                      variant="outlined"
                      sx={{
                        fontFamily: '"Segoe UI", sans-serif',
                        fontSize: "13px",
                        fontWeight: "normal",
                        textAlign: "center",
                        color: "#e7000b",
                        textTransform: "capitalize",
                        borderRadius: "6px",
                        border: "solid 1px #e5e5e5",
                        "@media (max-width:600px)": {
                          width: "100%",
                        },
                      }}
                      onClick={handleCancel}
                    >
                      Cancel
                    </Button>
                  </Grid>
                )}
              </Grid>
            </Box>
          );
        })
      ) : (
        <Box>
          <Grid>No booking found</Grid>
        </Box>
      )}

      {showTicket && (
        <Dialog open={openDialog} onClose={handleClose} fullWidth maxWidth="md">
          <BusTicketView
            ticket={selectedTicket}
            showTicket={showTicket}
            onClose={() => setOpenDialog(false)}
            // ticket={selectedIndex}
            // onClose={handleClose}
            // autoDownload={autoDownload}
            // booking={selectedIndex}
          />
        </Dialog>
      )}
      {isDownload && (
        <div style={{ opacity: 0, display: isDownload ? "block" : "none" }}>
          <BusTicketView
            ticket={selectedTicket}
            showTicket={showTicket}
            onClose={() => setOpenDialog(false)}
            // ticket={selectedIndex}
            // onClose={handleClose}
            // autoDownload={autoDownload}
            // booking={selectedIndex}
          />
        </div>
      )}
      {/* <Box
        sx={{
          padding: "20px",
          borderRadius: "8px",
          border: "1px solid #e5e5e5",
          marginBottom: "15px",
        }}
      >
        <Grid container spacing={2}>
          <Grid size={{ md: 10, xs: 12 }}>
            <Typography
              sx={{
                fontFamily: '"Segoe UI", sans-serif',
                fontSize: "15px",
                fontWeight: "500",
                textAlign: "left",
                color: "#0e182b",
                marginRight: "4px",
              }}
            >
              <img
                src={Deliveryimg1}
                alt=""
                style={{ verticalAlign: "middle", marginRight: "5px" }}
              />
              RB123456789{" "}
              <span
                style={{
                  padding: "3px 6px",
                  borderRadius: "6px",
                  backgroundColor: "#beffd0",
                  fontSize: "13px",
                  fontWeight: "500",
                  color: "#1e5d2f",
                }}
              >
                Completed
              </span>
            </Typography>
          </Grid>
          <Grid size={{ md: 2, xs: 12 }} sx={{ textAlign: "end" }}>
            <Typography
              sx={{
                fontFamily: '"Segoe UI", sans-serif',
                fontSize: "16px",
                fontWeight: 600,
                textAlign: "right",
                color: "#030213",
                "@media (max-width:600px)": {
                  textAlign: "left",
                },
              }}
            >
              ₹1000
            </Typography>
          </Grid>
        </Grid>
        <Grid container spacing={2} sx={{ marginTop: "20px" }}>
          <Grid size={{ md: 4, xs: 12 }}>
            <Typography
              sx={{
                fontFamily: '"Segoe UI", sans-serif',
                fontSize: "14px",
                fontWeight: "normal",
                textAlign: "left",
                color: "#717182",
              }}
            >
              Route
            </Typography>
            <Typography
              sx={{
                fontFamily: '"Segoe UI", sans-serif',
                fontSize: "14px",
                fontWeight: "normal",
                textAlign: "left",
                color: "#0e182b",
              }}
            >
              Chennai → Bengaluru
            </Typography>
          </Grid>
          <Grid size={{ md: 4, xs: 12 }}>
            <Typography
              sx={{
                fontFamily: '"Segoe UI", sans-serif',
                fontSize: "14px",
                fontWeight: "normal",
                textAlign: "left",
                color: "#717182",
              }}
            >
              Date & Time
            </Typography>
            <Typography
              sx={{
                fontFamily: '"Segoe UI", sans-serif',
                fontSize: "14px",
                fontWeight: "normal",
                textAlign: "left",
                color: "#0e182b",
              }}
            >
              2025-01-15 at 22:30
            </Typography>
          </Grid>
          <Grid size={{ md: 4, xs: 12 }}>
            <Typography
              sx={{
                fontFamily: '"Segoe UI", sans-serif',
                fontSize: "14px",
                fontWeight: "normal",
                textAlign: "left",
                color: "#717182",
              }}
            >
              Operator
            </Typography>
            <Typography
              sx={{
                fontFamily: '"Segoe UI", sans-serif',
                fontSize: "14px",
                fontWeight: "normal",
                textAlign: "left",
                color: "#0e182b",
              }}
            >
              VRL Travels
            </Typography>
          </Grid>
        </Grid>
        <Grid
          container
          spacing={2}
          sx={{ marginTop: "20px", alignItems: "center" }}
        >
          <Grid size={{ md: 8, xs: 12 }}>
            <Typography
              sx={{
                fontFamily: '"Segoe UI", sans-serif',
                fontSize: "14px",
                fontWeight: "normal",
                textAlign: "left",
                color: "#717182",
              }}
            >
              2 passengers
            </Typography>
          </Grid>
          <Grid
            size={{ md: 4, xs: 12 }}
            sx={{
              textAlign: "end",
              "@media (max-width:600px)": {
                textAlign: "unset",
              },
            }}
          >
            <Button
              variant="outlined"
              sx={{
                fontFamily: '"Segoe UI", sans-serif',
                fontSize: "13px",
                fontWeight: "normal",
                textAlign: "center",
                color: "#0e182b",
                textTransform: "capitalize",
                borderRadius: "6px",
                border: "solid 1px #e5e5e5",
                marginRight: "10px",
              }}
            >
              View Ticket
            </Button>
            <Button
              variant="outlined"
              sx={{
                fontFamily: '"Segoe UI", sans-serif',
                fontSize: "13px",
                fontWeight: "normal",
                textAlign: "center",
                color: "#0e182b",
                textTransform: "capitalize",
                borderRadius: "6px",
                border: "solid 1px #e5e5e5",
              }}
            >
              Modify
            </Button>
          </Grid>
        </Grid>
      </Box>
      <Box
        sx={{
          padding: "20px",
          borderRadius: "8px",
          border: "1px solid #e5e5e5",
          marginBottom: "15px",
        }}
      >
        <Grid container spacing={2}>
          <Grid size={{ md: 10, xs: 12 }}>
            <Typography
              sx={{
                fontFamily: '"Segoe UI", sans-serif',
                fontSize: "15px",
                fontWeight: "500",
                textAlign: "left",
                color: "#0e182b",
                marginRight: "4px",
              }}
            >
              <img
                src={Deliveryimg2}
                alt=""
                style={{ verticalAlign: "middle", marginRight: "5px" }}
              />
              RB123456789{" "}
              <span
                style={{
                  padding: "3px 6px",
                  borderRadius: "6px",
                  backgroundColor: "#ffe5e6",
                  fontSize: "13px",
                  fontWeight: "500",
                  color: "#791811",
                }}
              >
                Cancelled
              </span>
            </Typography>
          </Grid>
          <Grid
            size={{ md: 2, xs: 12 }}
            sx={{
              textAlign: "end",
              "@media (max-width:600px)": {
                textAlign: "unset",
              },
            }}
          >
            <Typography
              sx={{
                fontFamily: '"Segoe UI", sans-serif',
                fontSize: "16px",
                fontWeight: 600,
                textAlign: "right",
                color: "#030213",
                "@media (max-width:600px)": {
                  textAlign: "left",
                },
              }}
            >
              ₹1000
            </Typography>
          </Grid>
        </Grid>
        <Grid container spacing={2} sx={{ marginTop: "20px" }}>
          <Grid size={{ md: 4, xs: 12 }}>
            <Typography
              sx={{
                fontFamily: '"Segoe UI", sans-serif',
                fontSize: "14px",
                fontWeight: "normal",
                textAlign: "left",
                color: "#717182",
              }}
            >
              Route
            </Typography>
            <Typography
              sx={{
                fontFamily: '"Segoe UI", sans-serif',
                fontSize: "14px",
                fontWeight: "normal",
                textAlign: "left",
                color: "#0e182b",
              }}
            >
              Chennai → Bengaluru
            </Typography>
          </Grid>
          <Grid size={{ md: 4, xs: 12 }}>
            <Typography
              sx={{
                fontFamily: '"Segoe UI", sans-serif',
                fontSize: "14px",
                fontWeight: "normal",
                textAlign: "left",
                color: "#717182",
              }}
            >
              Date & Time
            </Typography>
            <Typography
              sx={{
                fontFamily: '"Segoe UI", sans-serif',
                fontSize: "14px",
                fontWeight: "normal",
                textAlign: "left",
                color: "#0e182b",
              }}
            >
              2025-01-15 at 22:30
            </Typography>
          </Grid>
          <Grid size={{ md: 4, xs: 12 }}>
            <Typography
              sx={{
                fontFamily: '"Segoe UI", sans-serif',
                fontSize: "14px",
                fontWeight: "normal",
                textAlign: "left",
                color: "#717182",
              }}
            >
              Operator
            </Typography>
            <Typography
              sx={{
                fontFamily: '"Segoe UI", sans-serif',
                fontSize: "14px",
                fontWeight: "normal",
                textAlign: "left",
                color: "#0e182b",
              }}
            >
              VRL Travels
            </Typography>
          </Grid>
        </Grid>
        <Grid
          container
          spacing={2}
          sx={{ marginTop: "20px", alignItems: "center" }}
        >
          <Grid size={{ md: 8, xs: 12 }}>
            <Typography
              sx={{
                fontFamily: '"Segoe UI", sans-serif',
                fontSize: "14px",
                fontWeight: "normal",
                textAlign: "left",
                color: "#717182",
              }}
            >
              2 passengers
            </Typography>
          </Grid>
          <Grid
            size={{ md: 4, xs: 12 }}
            sx={{
              textAlign: "end",
              "@media (max-width:600px)": {
                textAlign: "unset",
              },
            }}
          >
            <Button
              variant="outlined"
              sx={{
                fontFamily: '"Segoe UI", sans-serif',
                fontSize: "13px",
                fontWeight: "normal",
                textAlign: "center",
                color: "#0e182b",
                textTransform: "capitalize",
                borderRadius: "6px",
                border: "solid 1px #e5e5e5",
                marginRight: "10px",
              }}
            >
              View Ticket
            </Button>
            <Button
              variant="outlined"
              sx={{
                fontFamily: '"Segoe UI", sans-serif',
                fontSize: "13px",
                fontWeight: "normal",
                textAlign: "center",
                color: "#0e182b",
                textTransform: "capitalize",
                borderRadius: "6px",
                border: "solid 1px #e5e5e5",
              }}
            >
              Download
            </Button>
          </Grid>
        </Grid>
      </Box> */}
    </>
  );
};

const BookingHistory = () => {
  const [bookingHistory, setBookingHistory] = useState([]);
  const [value, setValue] = useState(1);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const history = async () => {
    try {
      const apiResponse = await AuthAxios({
        url: "/get_bookings",
        method: "post",
        payload: {
          filter_flag: value,
          // filter_flag: value + 1,
        },
      });
      if (apiResponse.status) {
        setBookingHistory(apiResponse?.data);
        console.log("value", apiResponse?.data);
      } else {
        setBookingHistory([]);
        showToast("error", apiResponse?.message);
      }
    } catch (error) {
      setBookingHistory([]);
      showToast("error", error.message);
    }
  };

  useEffect(() => {
    history();
  }, [value]);

  return (
    <>
      <Grid
        container
        spacing={2}
        sx={{ display: "flex", alignItems: "center", marginBottom: "20px" }}
      >
        <Grid size={{ md: 6, xs: 12 }}>
          <Typography
            sx={{
              fontFamily: '"Segoe UI", sans-serif',
              fontSize: "17px",
              fontWeight: 600,
              textAlign: "left",
              color: "#0e182b",
            }}
          >
            Booking History
          </Typography>
          <Typography
            sx={{
              fontFamily: '"Segoe UI", sans-serif',
              fontSize: "14px",
              fontWeight: "normal",
              textAlign: "left",
              color: "#717182",
            }}
          >
            View all your past and upcoming bookings
          </Typography>
        </Grid>
        <Grid size={{ md: 6, xs: 12 }} sx={{ textAlign: "end" }}>
          {/* Tabs */}
          <Box>
            <Tabs
              value={value}
              onChange={handleChange}
              variant="fullWidth"
              sx={{
                "& .MuiTab-root": {
                  textTransform: "none",
                  borderRadius: "30px",
                  fontWeight: 600,
                  color: "#364252",
                  padding: "4px 8px",
                  fontFamily: '"Segoe UI", sans-serif',
                  fontSize: "14px",
                  minHeight: "40px",
                  "@media (max-width:600px)": {
                    padding: "5px 0px",
                  },
                  "&.Mui-selected": {
                    bgcolor: "#fff",
                    color: "#364252",
                    fontFamily: '"Segoe UI", sans-serif',
                    fontSize: "14px",
                    border: "1px solid #ddd",
                    borderRadius: "5px",
                  },
                },
                "& .MuiTabs-indicator": { display: "none" },
              }}
            >
              <Tab label="All" value={1} />
              <Tab label="Upcoming" value={2} />
              <Tab label="Completed" value={3} />
              <Tab label="Cancelled" value={4} />
            </Tabs>
          </Box>
        </Grid>
      </Grid>
      <Grid container spacing={2} sx={{ marginTop: "10px" }}>
        <Grid size={{ md: 12, xs: 12 }}>
          <History bookingHistory={bookingHistory} value={value} />

          {/* {value === 1 && <History bookingHistory={bookingHistory} />}
          {value === 2 && <History bookingHistory={bookingHistory} />}
          {value === 3 && <History bookingHistory={bookingHistory} />}
          {value === 4 && <History bookingHistory={bookingHistory} />} */}
        </Grid>
      </Grid>
    </>
  );
};

export default BookingHistory;
